import { Component, EventEmitter, Output, input, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '@coin/admin/core/util';
import { NgClass } from '@angular/common';
import { AppCardComponent } from '../app-card/app-card.component';
import { DynamicDomAccessDirective } from '@coin/shared/auth/feature';

@Component({
  selector: 'admin-app-cards',
  templateUrl: './app-cards.component.html',
  styleUrls: ['./app-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, AppCardComponent, DynamicDomAccessDirective]
})
export class AppCardsComponent {
  readonly menuItems = input<MenuItem[]>(undefined);
  readonly type = input<'primary' | 'secondary'>('primary');
  readonly translationPrefix = input<string>(undefined);

  @Output() openClicked: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  public get activeMenuItems(): MenuItem[] {
    return this.menuItems()?.filter(menuItem => menuItem.active);
  }
}
